import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ShortSummary, GetShortSummary } from "../../../services/AdminService";
import { FaSave, FaPlus, FaArrowLeft } from "react-icons/fa";
// import "./Template.css";

const TemplateSummary = () => {
  const { templateUuid } = useParams();
  const navigate = useNavigate();
  const [templateTitle, setTemplateTitle] = useState("");
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchSummary = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await GetShortSummary({ template_uuid: templateUuid });
      const data = res.data?.data;
      setTemplateTitle(data?.template_title || "");
      setSummary(Array.isArray(data?.summary) ? data.summary : []);
    } catch {
      setError("Failed to load summary.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchSummary(); }, [templateUuid]);

  const handleChange = (index, field, value) => {
    const updated = [...summary];
    updated[index][field] = value;
    setSummary(updated);
  };

  const addRow = () => {
    setSummary([
      ...summary,
      { field_name: "", field_value: "" }
    ]);
  };

  const saveSummary = async () => {
    setLoading(true);
    try {
      const payload = {
        template_uuid: templateUuid,
        summary: summary.map(item => ({
          ...(item.id ? { id: item.id } : {}),
          field_name: item.field_name,
          field_value: item.field_value
        }))
      };
      await ShortSummary(payload);
      navigate(`/back-admin/template`);
    } catch {
      setError("Failed to save summary");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-temp-container">
      <div className="admin-temp-title">
        Template: {templateTitle}
      </div>
      {error && <div className="admin-temp-error">{error}</div>}

      <div className="admin-temp-fields-card">
        <div className="admin-temp-fields-header-row">
          <div>Field Name</div>
          <div>Field Value</div>
        </div>
        {loading ? (
          <div className="admin-temp-loading">Loading...</div>
        ) : summary.length === 0 ? (
          <div className="admin-temp-empty-message">No fields added yet.</div>
        ) : (
          summary.map((item, idx) => (
            <div className="admin-temp-field-row" key={idx}>
              <div className="admin-temp-input">
                <input
                  type="text"
                  value={item.field_name}
                  onChange={e => handleChange(idx, "field_name", e.target.value)}
                  placeholder="Enter field name..."
                />
              </div>
              <div className="admin-temp-input">
                <input
                  type="text"
                  value={item.field_value}
                  onChange={e => handleChange(idx, "field_value", e.target.value)}
                  placeholder="Enter value..."
                />
              </div>
            </div>
          ))
        )}
        <div className="admin-temp-fields-add-btn-row">
          <button className="btn btn-outline-primary" onClick={addRow} disabled={loading}>
            <FaPlus style={{ marginRight: 8 }} /> Add Field
          </button>
        </div>
      </div>

      <div className="admin-temp-btn-row">
        <button className="btn btn-outline-secondary" onClick={() => navigate(-1)} disabled={loading}>
          <FaArrowLeft style={{ marginRight: 8 }} /> Back
        </button>
        <button className="btn btn-primary" onClick={saveSummary} disabled={loading}>
          <FaSave style={{ marginRight: 8 }} /> Save Summary
        </button>
      </div>
    </div>
  );
};

export default TemplateSummary;
